module.exports = __webpack_public_path__ + "img/menu-bg1.0f94fa7a.png";